module.exports = __webpack_public_path__ + "f48981fe7bdc01a9d924064d1d901da7.woff";


//////////////////
// WEBPACK FOOTER
// ./src/main/webapp/content/fonts/ArialMT-Medium.woff
// module id = 364
// module chunks = 1